<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter">
<span epub:type="pagebreak" id="p31" title="31">
<p class="icon"><span class="grey">[</span> QUICK PREP <span class="grey">]</span></p>
<h2 class="recipetitle" id="make_it_your_own_oatmeal">Make-It-Your-Own Oatmeal</h2>
<p class="recipetime"><span class="yield_black">1 serving</span> <span class="separater">|</span> Prep Time: 5 Minutes <span class="separater">|</span> Start to Finish: 8 Hours 5 Minutes</p>
<p class="dot">•••</p>
<p class="ingredient_head">OATMEAL</p>
<ul class="ingredient1">
<li class="list"><span class="qty1">1</span> container (5.3 oz) 100-calorie fat-free Greek yogurt (any flavor)</li>
<li class="list"><span class="qty1">¼</span> cup old-fashioned or quick-cooking oats</li>
<li class="list"><span class="qty1">1</span> teaspoon chia seed</li>
</ul>
<p class="ingredient_head">STIR-INS (SEE BELOW)</p>
<p class="recipeprocedure"><span class="stepnum">1</span> In container with tight-fitting cover, mix yogurt, oats and chia seed. Add desired stir-ins.</p>
<p class="recipeprocedure"><span class="stepnum">2</span> Cover; refrigerate at least 8 hours but no longer than 3 days.</p>
<p class="recipe_info"><span class="nutr_bold">1 Serving:</span> Calories 190; Total Fat 2g (Saturated Fat 0g, Trans Fat 0g); Cholesterol 0mg; Sodium 45mg; Total Carbohydrate 29g (Dietary Fiber 3g); Protein 13g <span class="nutr_bold">Exchanges:</span> ½ Starch, 1 Other Carbohydrate, ½ Skim Milk, 1 Very Lean Meat <span class="nutr_bold">Carbohydrate Choices:</span> 2</p>
<p class="recipe_variation"><span class="variation_lead">Almond Oatmeal:</span> Stir in ¼ cup toasted almonds. Calories 330 (Calories from Fat 120); Total Fat 13g (Saturated Fat 1g, Trans Fat 0g); Cholesterol 0mg; Sodium 55mg; Potassium 240mg; Total Carbohydrate 31g (Dietary Fiber 6g); Protein 21g</p>
<p class="recipe_variation"><span class="variation_lead">Banana Oatmeal:</span> Stir in ¼ cup banana slices. Calories 220 (Calories from Fat 20); Total Fat 2g (Saturated Fat 0g, Trans Fat 0g); Cholesterol 0mg; Sodium 55mg; Potassium 210mg; Total Carbohydrate 34g (Dietary Fiber 4g); Protein 16g</p>
<p class="recipe_variation"><span class="variation_lead">Blackberry Oatmeal:</span> Stir in ¼ cup blackberries. Calories 200 (Calories from Fat 20); Total Fat 2.5g (Saturated Fat 0g, Trans Fat 0g); Cholesterol 0mg; Sodium 55mg; Potassium 135mg; Total Carbohydrate 29g (Dietary Fiber 5g); Protein 16g</p>
<p class="recipe_variation"><span class="variation_lead">Blueberry Oatmeal:</span> Stir in ¼ cup blueberries. Calories 210 (Calories from Fat 20); Total Fat 2g (Saturated Fat 0g, Trans Fat 0g); Cholesterol 0mg; Sodium 55mg; Potassium 105mg; Total Carbohydrate 31g (Dietary Fiber 4g); Protein 16g</p>
<p class="recipe_variation"><span class="variation_lead">Honey Oatmeal:</span> Stir in 1 tablespoon honey or 2 tablespoons comb honey.* Calories 260 (Calories from Fat 20); Total Fat 2g (Saturated Fat 0g, Trans Fat 0g); Cholesterol 0mg; Sodium 60mg; Potassium 90mg; Total Carbohydrate 43g (Dietary Fiber 3g); Protein 16g</p>
<p class="recipe_variation"><span class="variation_lead">Pomegranate Oatmeal:</span> Stir in ¼ cup pomegranate seeds. Calories 230 (Calories from Fat 25); Total Fat 2.5g (Saturated Fat 0g, Trans Fat 0g); Cholesterol 0mg; Sodium 60mg; Potassium 180mg; Total Carbohydrate 34g (Dietary Fiber 4g); Protein 16g</p>
<p class="recipefootnote">*Those with bee sting allergies should consult their physician before consuming comb honey.</p>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p031.vue?9828cb66